// extracted by mini-css-extract-plugin
export var logo = "_kr-2";
export var logoWrapper = "_kr-1";
export var strip = "_kr-0";